import { ServiceDetailPage } from '../../components/ServiceDetailPage';
import { SERVICE_BESZEDESZLELES } from '../../data/content';
import { Helmet } from 'react-helmet-async';

export default function SpeechPerceptionPage() {
  return (
    <>
      <Helmet>
        <title>Beszédészlelés és Beszédmegértés Fejlesztése | Mosolytorna</title>
        <meta name="description" content="Beszédészlelési és beszédmegértési nehézségek diagnosztizálása és célzott, játékos fejlesztése GMP diagnosztika alapján." />
      </Helmet>
      
      <ServiceDetailPage service={SERVICE_BESZEDESZLELES} />
    </>
  );
}
